import PopupMessage from "shared/components/PopupMessage";
import { useMeasure } from "./useMeasure";
import { RootState } from "app/store";
import { useRef } from "react";
import { Transition } from "react-transition-group";
import { TransitionProps } from "react-transition-group/Transition";
import { normaliseValue } from "shared/helpers/unitHelpers";

/**
 * `$transitionShort` out
 * `$transitionShort` in
 *
 * Same as PageBottomMenu
 * Linked to PageBottomMenu, KeyButtons, MeasureButtons, PageBottomMenu
 */
const TIMEOUTS: TransitionProps["timeout"] = {
  enter: 0,
  appear: 300,
  exit: 300,
};

interface MeasureProps {
  measureMode: RootState["krpano"]["measureMode"];
  imperialUnits: boolean;
}

const Measure: React.FC<MeasureProps> = ({ measureMode, imperialUnits }) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const [measuredResult, closePanel] = useMeasure(measureMode);

  const units: Parameters<typeof normaliseValue>[2] = imperialUnits
    ? "imperial"
    : "metric";

  return (
    <>
      {/* Measure result message */}
      {!!measuredResult && (
        <PopupMessage
          closeButton="Clear measurement"
          widthClass="FullWidth"
          closePanel={closePanel}
          children={
            <p>
              {measuredResult &&
                ("message" in measuredResult
                  ? measuredResult.message
                  : `Calculated distance: ${normaliseValue(
                      measuredResult.result,
                      "distance",
                      units,
                      " [unit]",
                      "long"
                    )}`)}
            </p>
          }
        />
      )}
      {/* "in progress" footer element */}
      <Transition
        nodeRef={nodeRef}
        in={measureMode === "IN_PROGRESS"}
        timeout={TIMEOUTS}
        mountOnEnter
        unmountOnExit
      >
        {(transitionState) => (
          <footer
            ref={nodeRef}
            className={`PageBottomMenu MeasureMessage ${transitionState}`}
          >
            <div className="Left DisplayFlex LargeGap">
              <span>Measuring in progress...</span>
            </div>
          </footer>
        )}
      </Transition>
    </>
  );
};

export default Measure;
